import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from './services/guard/auth-guard.service';
import {LoggedInAuthGuardService} from './services/guard/logged-in-auth-guard.service';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
        canActivate: [AuthGuardService]
    },
    {
        path: 'login',
        loadChildren: () => import('./pages/authentication/login/login.module').then(m => m.LoginPageModule),
        canActivate: [LoggedInAuthGuardService]
    },
    {
        path: 'register',
        loadChildren: () => import('./pages/authentication/register/register.module').then(m => m.RegisterPageModule),
        canActivate: [LoggedInAuthGuardService]
    },
    {
        path: 'forget-password',
        loadChildren: () => import('./pages/authentication/forget-password/forget-password.module').then(m => m.ForgetPasswordPageModule),
        canActivate: [LoggedInAuthGuardService]
    },
    {
        path: 'activate-token/:username',
        pathMatch: 'full',
        canActivate: [LoggedInAuthGuardService],
        loadChildren: () => import('./pages/authentication/activate-token/activate-token.module').then(m => m.ActivateTokenPageModule)
    },
    {
        path: 'package',
        loadChildren: () => import('./pages/package/package.module').then(m => m.PackagePageModule),
        canActivate: [AuthGuardService]
    },
    {
        path: 'profile',
        loadChildren: () => import('./pages/authentication/profile/profile.module').then(m => m.ProfilePageModule),
        canActivate: [AuthGuardService]
    },
    {
        path: 'report',
        loadChildren: () => import('./pages/report/report.module').then(m => m.ReportPageModule),
        canActivate: [AuthGuardService]
    },
    {
        path: 'errors/:errorCode/:errorMessage',
        loadChildren: () => import('./pages/errors/errors.module').then(m => m.ErrorsPageModule)
    },
    {
        path: 'show-message',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./pages/show-message/show-message.module').then(m => m.ShowMessagePageModule)
    },
    {
        path: 'help',
        loadChildren: () => import('./pages/help/help.module').then(m => m.HelpPageModule),
        canActivate: [AuthGuardService],
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
